import { useEffect, useState } from 'react';

const pad = (n) => String(n).padStart(2, '0');

const DateTimeNow = () => {
  const [now, setNow] = useState(new Date());

  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(id);
  }, []);

  const hours   = pad(now.getHours());
  const minutes = pad(now.getMinutes());

  const date = now.toLocaleDateString('fr-FR', {
    weekday: 'short', day: 'numeric', month: 'short',
  });

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      gap: 10,
      padding: '6px 12px',
      borderRadius: 10,
      background: '#f9fafb',
      border: '1.5px solid #f0f0f0',
      userSelect: 'none',
    }}>
      {/* Divider bar */}
      <div style={{ width: 3, height: 28, borderRadius: 99, background: '#e5e7eb' }} />

      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 1 }}>
        {/* Time row — hours and minutes only: ticking seconds pulled the eye for nothing */}
        <span style={{
          fontSize: 15,
          fontWeight: 700,
          color: '#111827',
          fontVariantNumeric: 'tabular-nums',
          letterSpacing: '0.3px',
          lineHeight: 1,
        }}>
          {hours}:{minutes}
        </span>

        {/* Date row */}
        <span style={{
          fontSize: 11,
          color: '#9ca3af',
          fontWeight: 500,
          textTransform: 'capitalize',
          lineHeight: 1,
          letterSpacing: '0.2px',
        }}>
          {date}
        </span>
      </div>
    </div>
  );
};

export default DateTimeNow;
